<template>
  <v-row justify="center">
    <v-col xl="10">
      <v-card>
        <v-card-title>
          <h2>{{ $t("admin.events.title") }}</h2>
          <v-dialog max-width="600px" v-model="createDialog">
            <template v-slot:activator="{ on }">
              <v-btn :icon="$vuetify.breakpoint.smAndDown" class="ml-5" color="primary" text v-on="on">
                <v-icon left>mdi-calendar-plus</v-icon>
                <span class="hidden-sm-and-down">{{ $t("admin.events.actions.add") }}</span>
              </v-btn>
            </template>
            <v-card>
              <v-form @submit.prevent="createEvent" ref="createForm" v-model="valid">
                <v-card-title>
                  <span class="headline">{{ $t("admin.events.create.title") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    :label="$t('admin.events.create.eventName')"
                    :rules="[$v.required()]"
                    autocomplete="off"
                    name="newEventName"
                    required
                    v-model="newEvent.name"
                  ></v-text-field>
                  <v-text-field
                    :label="$t('admin.events.create.slug')"
                    :rules="[$v.required(), $v.maxLength(255)]"
                    name="newEventSlug"
                    v-model="newEvent.slug"
                    :error-messages="notUniqueSlugMessage"
                    @keydown="clearSlugMessage"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!valid" color="primary" type="submit">
                    {{ $t("admin.events.create.submit") }}
                  </v-btn>
                  <v-btn @click="createDialog = false" color="secondary" text>
                    {{ $t("admin.events.create.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field
            :label="$t('admin.events.actions.search')"
            append-icon="mdi-magnify"
            hide-details
            single-line
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :options.sync="pagination"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="id"
        >
          <template v-slot:item.id="props">
            <v-btn raised color="primary" :to="`/admin/event/${props.item.id}`">
              {{ $t("admin.app.events.actions.manage") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import debounce from "../../../util/debounce";
import slugify from "slugify";

export default {
  data() {
    return {
      valid: false,
      totalItems: 0,
      items: [],
      loading: true,
      newEvent: {
        name: "",
        slug: "",
      },
      createDialog: false,
      pagination: {
        itemsPerPage: 25,
      },
      search: "",
      headers: [{ text: this.$t("admin.events.list.name"), value: "name" }, { value: "id" }],
      notUniqueSlugMessage: null,
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    search: {
      handler() {
        debounce(this.getDataFromApi);
      },
      deep: true,
    },
    "newEvent.name": {
      handler() {
        this.newEvent.slug = slugify(`${this.newEvent.name.toLowerCase()}`, {
          lower: true,
          strict: true,
        });
      },
    },
  },
  methods: {
    async createEvent() {
      if (!this.$data.valid) return;

      const exist = await this.$axios.get("/admin/events/isSlugExist", { params: { slug: this.newEvent.slug }});
      if (exist) {
        this.notUniqueSlugMessage = this.$t("errors.validator.notUniqueSlugMessage");
        return;
      }

      await this.$axios.post("/admin/events", {
        name: this.newEvent.name,
        slug: this.newEvent.slug,
      });
      this.createDialog = false;
      await this.getDataFromApi();
    },
    async getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.loading = true;
      const result = await this.$axios.get("/admin/events", {
        params: {
          page: page - 1,
          size: itemsPerPage,
          sortBy: sortBy.join(","),
          sortOrder: sortDesc.map((s) => (s ? "desc" : "asc")).join(","),
          search: this.search || undefined,
        },
      });
      this.items = result.rows;
      this.totalItems = result.count;
      this.loading = false;
    },
    clearSlugMessage() {
      this.notUniqueSlugMessage = null;
      this.$refs.createForm.resetValidation();
    },
  },
};
</script>

<style scoped></style>
